<template>
  <div>
    <div class="mb-12">
      <button 
        @click="toggleCollapse" 
        class="w-full cursor-pointer focus:outline-none border-light-gray-4"
        :class="isCollapsed ? 'rounded-t-md border-t border-l border-r' : 'rounded-md border' "
      >
        <div class="container flex items-center justify-between p-20 gap-20 text-left">
          <slot name="heading"></slot>
          <i v-if="isCollapsed" class="fas fa-minus text-orange"></i>
          <i v-else class="fas fa-plus text-orange"></i>
        </div>
      </button>
      <div 
        v-if="isCollapsed" 
        class="text-left px-18 lg:px-20 border-light-gray-4"
        :class="isCollapsed ? 'rounded-b-md border-b border-l border-r' : ''"
      >
          <slot name="body"></slot>
        </div>
    </div>
  
  </div>
</template>
<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      isOpen: this.open,
      isCollapsed: false,
    }
  },

  computed: {
    isOpenClass () {
      return this.isOpen ? 'h-auto' : 'h-0'
    }
  },

  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
  },
}
</script>
